
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-administration",
  components: {},
})
export default class IconAdministration extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
